import {mapGetters} from "vuex";
import { filterOptionsByQuery } from "@/utils/helpers";

function generateSelectedComputed(name, filterName) {
    return {
        get() {
            return this[name].filter(item => this.filters[filterName].includes(item.id.toString()));
        },
        set(items) {
            this.filters[filterName] = items.map(item => item.id.toString());
        }
    }
}

export default {
    props: {
        fetchOnCreated: {
            type: Boolean,
            default: false,
        },
    },
    async created() {
        this.initializeFiltersAndData();
    },
    computed: {
        ...mapGetters('Platforms', [
            'platforms',
        ]),
        ...mapGetters('TestSuites', [
            'testSuiteNames',
        ]),
        ...mapGetters('TestRuns', [
            'mtrNames',
        ]),
        ...mapGetters('TargetBuilds', [
            'branches',
            'products',
            'additionalTools',
            'buildTypes',
            'ciServices',
        ]),
        ...mapGetters('TestCases', [
            'testCases',
            'testCasesTotalCount',
        ]),
        selectedProducts: generateSelectedComputed('products', 'product_ids'),
        filteredProducts() {
            return filterOptionsByQuery(this.products, this.queries.product, this.selectedProducts,
                (product) => product.name);
        },
        selectedPlatforms: generateSelectedComputed('platforms', 'platform_ids'),
        filteredPlatforms() {
            return filterOptionsByQuery(this.platforms, this.queries.platform, this.selectedPlatforms,
                (platform) => platform.name);
        },
        selectedBranches: generateSelectedComputed('branches', 'branch_ids'),
        filteredBranches() {
            return filterOptionsByQuery(this.branches, this.queries.branch, this.selectedBranches,
                (branch) => branch.name);
        },
        selectedCIServices: generateSelectedComputed('ciServices', 'ci_service_ids'),
        filteredCIServices() {
            return filterOptionsByQuery(this.ciServices, this.queries.ciService, this.selectedCIServices,
                (ciService) => ciService.name);
        },
        selectedBuildTypes: generateSelectedComputed('buildTypes', 'build_type_ids'),
        filteredBuildTypes() {
            return filterOptionsByQuery(this.buildTypes, this.queries.buildType, this.selectedBuildTypes,
                (buildType) => buildType.name);
        },
        selectedAdditionalTools: generateSelectedComputed('additionalTools', 'additional_tool_ids'),
        filteredAdditionalTools() {
            return filterOptionsByQuery(this.additionalTools, this.queries.additionalTool, this.selectedAdditionalTools,
                (additionalTool) => additionalTool.name);
        },
        selectedMtrNames: generateSelectedComputed('mtrNames', 'mtr_ids'),
        filteredMtrNames() {
            return filterOptionsByQuery(this.mtrNames, this.queries.mtrName, this.selectedMtrNames,
                (mtr) => mtr.name);
        },
        selectedTestSuiteNames: generateSelectedComputed('testSuiteNames', 'test_suite_name_ids'),
        filteredTestSuiteNames() {
            return filterOptionsByQuery(this.testSuiteNames, this.queries.testSuiteName,
                this.selectedTestSuiteNames, (suite) => suite.name);
        },
    },
    methods: {
        async initializeFiltersAndData() {
            this.setFiltersByQuery(this.$route.query);
            const doSearch = Object.keys(this.$route.query).length > 0 || this.fetchOnCreated;
            await this._fetchData(doSearch);
        },
        async afterSearch() {},
        async onSearchClick() {
            await this.$router.push({
                name: this.$route.name,
                query: this.createQueryFromFilters(),
            });
            await this.search();
            await this.afterSearch();
        },
        createQueryFromFilters() {
            const dates = this.filters.dates.map(item => item.toJSON());
            return Object.assign({}, this.filters, {dates});
        },
        async _fetchData(doSearch = false) {
            this.isLoading = true;
            try {
                await Promise.all(this.fetchData());
                await this.setFiltersByName();
                if (doSearch) {
                    await this.search();
                    this.$router.replace({
                        name: this.$route.name,
                        query: Object.assign(
                            this.createQueryFromFilters(), 
                            {
                                page: this.currentPage,
                                rowsPage: this.rowsCurrentPage,
                            }
                        ),
                    });
                } else {
                    this.clearData();
                }
            } catch(message) {
                this.error = message;
            }
            this.isLoading = false;
        },
    },
    watch: {
        '$route.name'(newName, oldName) {
            if (newName != oldName) {
                this.initializeFiltersAndData();
            }
        }
    }
}
